import BusinessAssetExport from "../locales/de/BusinessAssetExport.json";
import DeleteEmailDocumentModal from "../locales/de/DeleteEmailDocumentModal.json";
import CommandHub from "../locales/de/CommandHub.json";
import ContactUserModal from "../locales/de/ContactUserModal.json";
import CreateUser from "../locales/de/CreateUser.json";
import CsvImport from "../locales/de/CsvImport.json";
import DownloadTransactions from "../locales/de/DownloadTransactions.json";
import Navigation from "../locales/de/Navigation.json";
import Operators from "../locales/de/Operators.json";
import RemoveReceiptModal from "../locales/de/RemoveReceiptModal.json";
import ReceiptOverview from "../locales/de/ReceiptOverview.json";
import Rules from "../locales/de/Rules.json";
import ServiceTracker from "../locales/de/ServiceTracker.json";
import TaxCaseOverview from "../locales/de/TaxCaseOverview.json";
import TaxNumbers from "../locales/de/TaxNumbers.json";
import translation from "../locales/de/translation.json";
import TransactionFilters from "../locales/de/TransactionFilters.json";
import EuerVatTaxAccountCheck from "../locales/de/EuerVatTaxAccountCheck.json";
import VatAnnualDeclaration from "../locales/de/VatAnnualDeclaration.json";
import VatView from "../locales/de/VatView.json";
import ZmView from "../locales/de/ZmView.json";
import {
  bankingTranslations,
  documentTranslations,
} from "@/modules/integrations";
import { taxRegistrationTranslations } from "@/modules/tax-registration";
import { serviceTrackerExportTranslations } from "@/modules/service-tracker-export";
import { onboardingTranslations } from "@/modules/onboarding/i18n";

const translations = {
  translation,
  BusinessAssetExport,
  ServiceTracker,
  Navigation,
  Operators,
  CommandHub,
  ContactUserModal,
  CreateUser,
  CsvImport,
  DownloadTransactions,
  Banking: bankingTranslations.de,
  Documents: documentTranslations.de,
  TaxRegistration: taxRegistrationTranslations.de,
  ServiceTrackerExport: serviceTrackerExportTranslations.de,
  Onboarding: onboardingTranslations.de,
  TaxCaseOverview,
  TaxNumbers,
  TransactionFilters,
  DeleteEmailDocumentModal,
  RemoveReceiptModal,
  ReceiptOverview,
  Rules,
  EuerVatTaxAccountCheck,
  VatAnnualDeclaration,
  VatView,
  ZmView,
};
export default translations;
